import {get, listAll} from './utils';

const dao = {
  loadAuth: () => get('/smb-backend/auth/auth.action'),
  signOut: () => get('/smb-backend/auth/sign-out.action'),
  switchCustomer: customerId =>
    get('/smb-backend/auth/switch-customer.action', {customerId}),
  listCustomers: params =>
    get('/smb-backend/auth/list-customers.action', params),
  listAllCustomers: params => listAll(dao.listCustomers, params),
  listAccountService: params =>
    get('/smb-backend/customer/list-account-service.action', params),
  listTechnicalSupportCustomers: () =>
    get('/smb-backend/customer/list-technical-support-customers.action'),
  switchAccountCustomer: customerId =>
    get('/smb-backend/auth/switch-account-customer.action', {customerId}),
  checkBusinessName: async businessName => {
    const response = await fetch(
      '/smb-backend/auth/check-business-name.action',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({businessName}),
      }
    );
    if (response.ok) return await response.json();
    return Promise.reject({
      status: response.status,
      statusText: response.statusText,
    });
  },
};

export default dao;
